import { segment } from '@actions/analytics';
import segmentStorage from '@events/segmentStorage';
import cookies from '@utils/cookies';
import constants, { LOGIN_SUCCESSFUL, SIGNUP_SUCCESFUL } from '../constants';

const handleUnregisteredUserStepPostLogin = ({
  country,
  loginResponse,
  mobileNumber,
  loginType,
  isLoginTriggeredFromIframe,
  setStep,
  experimentData
}) => {
  if (isLoginTriggeredFromIframe) {
    segment.track(LOGIN_SUCCESSFUL, {
      ...(experimentData || {}),
      is_new_user: true,
      login_medium:
        loginType === constants.LOGIN_TYPE_EMAIL ? 'Email' : 'Mobile',
      screen: 'OTP',
      login_primary_source: segmentStorage.getItem('lps'),
      proxy_id: `${country?.code}${mobileNumber}`
    });
    segment.track(SIGNUP_SUCCESFUL, {
      is_new_user: true,
      login_medium:
        loginType === constants.LOGIN_TYPE_EMAIL ? 'Email' : 'Mobile',
      screen: 'OTP',
      login_primary_source: segmentStorage.getItem('lps'),
      proxy_id: `${country?.code}${mobileNumber}`
    });
  }
  cookies.setCookie(
    'partialUserAccessToken',
    loginResponse.access_token,
    3024000
  );
  setStep(constants.UPDATE_PARTIAL_USER_DETAILS_STEP);
};

export default handleUnregisteredUserStepPostLogin;
